interface HolifyaLogoIconProps {
  className?: string;
  width?: number;
  height?: number;
  color?: 'default' | 'white' | 'blue';
}

const HolifyaLogoIcon: React.FC<HolifyaLogoIconProps> = ({
  className = '',
  width = 37,
  height = 42,
  color = 'default'
}) => {
  // Color variants
  const colorVariants = {
    default: '#0068FF',
    white: '#FFFFFF',
    blue: '#0068FF'
  };

  const fillColor = colorVariants[color];

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 37 42" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M18.6208 0.507577C12.1964 1.91202 6.244 6.05339 3.22213 11.2241C1.71664 13.7975 1.77538 14.1137 3.84652 14.6589C4.83858 14.9206 5.81758 15.1365 6.02209 15.1408C6.22877 15.1452 7.09247 14.0875 7.94312 12.7899C10.9585 8.19058 17.4591 4.69692 23.035 4.67729C24.8146 4.67075 26.009 3.72646 26.009 2.32419C26.009 1.82697 25.6849 1.0964 25.2889 0.699489C24.4317 -0.159752 21.9973 -0.231718 18.623 0.507577M18.6208 8.76414C14.2283 9.88944 10.1513 13.3678 8.70457 17.2279C7.74949 19.7751 7.65594 23.3494 8.48048 25.8334C9.3159 28.3544 11.8091 31.3792 14.0608 32.607C21.9473 36.901 31.0455 29.484 28.4674 20.8611C27.6233 18.0413 23.4397 14.4517 21.5491 14.9271C20.3787 15.2215 17.7092 18.0217 16.9217 19.7838C16.5366 20.643 16.195 22.0802 16.1624 22.9765C16.1124 24.2981 16.2625 24.7386 16.9521 25.2991C18.6317 26.6643 20.3939 25.7854 20.8007 23.3799C21.0683 21.7901 21.8929 20.209 22.4563 20.209C22.6347 20.209 23.1025 20.7368 23.4941 21.3823C24.9996 23.8554 23.9879 27.1549 21.3055 28.5289C19.0537 29.6803 17.0261 29.3467 15.079 27.5017C13.245 25.7636 12.588 24.0058 12.7424 21.2493C12.8555 19.2386 13.0753 18.5167 13.9629 17.254C15.3226 15.3153 17.6962 13.828 20.3025 13.2784C22.0952 12.9011 22.576 12.9404 24.6167 13.6186L26.9141 14.3841L28.8764 13.0931L30.8388 11.802L29.7771 10.9471C27.2274 8.89281 22.0756 7.88527 18.6252 8.77068M32.1159 16.0764C31.4327 16.5867 30.6517 17.1319 30.3798 17.2889C29.9751 17.5223 30.0665 18.0326 30.8714 20.0477C31.7373 22.2154 31.8396 22.8805 31.6981 25.4277C31.5132 28.7905 30.717 30.6573 28.5283 32.8512C26.3397 35.0451 22.7631 36.563 18.6665 36.9141C17.7897 36.9882 17.5243 37.2739 16.9391 38.7765C15.9905 41.2059 16.1907 41.52 18.7013 41.5134C25.6479 41.496 32.0419 37.6904 34.9136 31.8677C36.1059 29.4492 36.2668 28.7884 36.3996 25.7658C36.4844 23.8227 36.3647 21.6527 36.1211 20.6779C35.6316 18.7283 34.0151 15.1496 33.6235 15.1496C33.4778 15.1496 32.8012 15.5661 32.118 16.0764M0.589696 18.4426C0.456986 18.8635 0.341681 20.5296 0.332979 22.1456C0.309047 27.3992 2.28446 32.1883 6.01339 35.9174C8.23247 38.1375 11.6307 40.2725 12.4444 39.9607C12.6946 39.8647 13.1036 39.1014 13.3538 38.2662C13.6039 37.4309 13.8824 36.5521 13.9738 36.3144C14.0652 36.0766 13.5583 35.6056 12.849 35.2654C11.1303 34.4432 8.13892 31.6016 7.07289 29.7785C5.54564 27.1658 5.06049 25.2642 5.06701 21.9297L5.07354 18.7784L3.22431 18.2289C1.6608 17.7636 0.783322 17.8356 0.591872 18.4448" 
        fill={fillColor}
      />
    </svg>
  );
};

export default HolifyaLogoIcon; 